// navigation/state.js

export const navigationInitialState = {
  activeTab: null,
  url: null,
};
